import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import SvgIcon from '@material-ui/core/SvgIcon';
import isEmpty from 'lodash/isEmpty';
import IoAdd from 'react-icons/lib/io/android-add-circle';
import IoCheckmark from 'react-icons/lib/io/checkmark';
import {ellipsisString, secondsToMinutes} from '../../../../utils/commonUtility';
import {DEFAULT_BEATS_METER, DEFAULT_BEATS_PER_BAR} from '../../../../constants/constants';
import {roundBpm} from '../../../../utils/audioUtility';
import Play from '../../../../assets/images/play-icon-card';
import Pause from '../../../../assets/images/pause-icon-card';
import {TrackPlayStatus} from '../../../../constants/enums';
import {secondary} from '../../../../themes/colors';

@observer
class LibraryTrack extends Component {
    handleClick = () => {
        const {isTrackAdded, addTrack, removeTrack} = this.props;
        if (isTrackAdded) {
            removeTrack();
        } else {
            addTrack();
        }
    };

    render() {
        const {track, isTrackAdded, playTrack} = this.props;
        const playCondition = +track.playStatus === TrackPlayStatus.Stopped || +track.playStatus === TrackPlayStatus.Paused;

        return (
            <div className="m-library-track">
                <div className="t-header">
                    {!isEmpty(track.instruments) && <ul>
                        {track.instruments.map((item, index) => (
                            <li key={index}>{item.name}</li>
                        ))}
                    </ul>}
                </div>
                <div className="t-body">
                    <div className="t-content">
                        <div className="t-name">{ellipsisString(track.name, 35)}</div>
                        <div className="t-owner"><FormattedMessage id="general.by" /> {track.owner.name}</div>
                    </div>
                    <div className="t-image" onClick={playTrack}>
                        <img src={track.backgroundImage} alt=""/>
                        {track.duration && <SvgIcon className="t-icon" viewBox="0 0 36 36">
                            {playCondition ? Play : Pause}
                        </SvgIcon>}
                    </div>
                </div>
                <div className="t-footer">
                    <div className="t-details">
                        <div className="t-footer-item">
                            {secondsToMinutes(track.duration, 'mm:ss') || '00:00'}
                        </div>
                        <div className="t-footer-item">
                            | {track.tsBeatsPerBar || DEFAULT_BEATS_PER_BAR}/{track.tsBeatsMeter || DEFAULT_BEATS_METER}
                        </div>
                        <div className="t-footer-item">
                            | {roundBpm(track.bpm)} <FormattedMessage id="studio.bpm" />
                        </div>
                    </div>
                    <div className="t-in-looper" onClick={this.handleClick}>
                        {isTrackAdded ? <IoCheckmark /> : <IoAdd style={{color: secondary}} />}
                    </div>
                </div>
            </div>
        );
    }
}

LibraryTrack.propTpyes = {
    track: PropTypes.object.isRequired,
    isTrackAdded: PropTypes.bool,
    playTrack: PropTypes.func,
    addTrack: PropTypes.func
};

export default LibraryTrack;
